

<template>
  <CContainer class="d-flex content-center min-vh-100">
  </CContainer>

</template>

<script>
import firebase from 'firebase'
export default {
  mounted(){
    firebase.auth().signOut();
    this.$router.push('/')
  }

}
</script>
